import {AxiosRequestConfig} from 'axios';

import {RecommendCodeUsingPapas} from '@/root/constants/recommendCode';
import {CreatedPapasTransaction, RecommendCardIntroResponse} from '@/root/models/recommend';

import {api} from '@/shared/utils/api';

export const getRecommendCardIntro = (code: string) => {
  return api<RecommendCardIntroResponse>('get', `/api/digitalcard/recommend/${code}/intro`);
};

export const createPapasTransaction = (code: RecommendCodeUsingPapas, options?: AxiosRequestConfig) => {
  return api<CreatedPapasTransaction>('post', `/card-types/${code}/transactions`, undefined, options);
};
